import React from "react";
import z from "zod";
import ProjectWidgetContent from "../../components/projectWidgetComponents/ProjectWidgetContent";
import { withValidatedProps } from "../../withValidatedProps";

export default withValidatedProps(
  z.object({
    orderWebhostingWidgetUrl: z.string(),
  }),
  (props) => {
    return (
      <ProjectWidgetContent orderWidgetUrl={props.orderWebhostingWidgetUrl} />
    );
  },
);
